// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MediaPage.css */

/* ========================================
   LOCAL TOKENS — mapped to global :root
   ======================================== */

:root {
  /* Typography — mapped from global */
  --scl--cms-pages-mediaPage-title-color:            var(--typography-text-body-primary);   /* #323539 */
  --scl--cms-pages-mediaPage-desc-color:             var(--typography-text-body-secondary); /* #8A8B8F */
  --scl--cms-pages-mediaPage-filter-color:           var(--input-defualt);                  /* #8A8B8F */
  --scl--cms-pages-mediaPage-filter-border:          var(--input-defualt);                  /* #8A8B8F */
  --scl--cms-pages-mediaPage-search-icon-color:      var(--typography-text-body-secondary); /* #8A8B8F */

  /* Upload button */
  --scl--cms-pages-mediaPage-upload-bg:              var(--secondarycolors-blue400);         /* #4E9FFF */
  --scl--cms-pages-mediaPage-upload-color:           var(--neutralcolors-100);              /* #FFFFFF */
  --scl--cms-pages-mediaPage-upload-divider:         rgba(241, 243, 247, 0.2);

  /* Dropdown menu */
  --scl--cms-pages-mediaPage-menu-item-hover:        var(--action-hover);                   /* #EFF3F8 */
  --scl--cms-pages-mediaPage-menu-item-active-color: var(--primarypalette-blue);            /* #2388FF */

  /* Table */
  --scl--cms-pages-mediaPage-table-row-hover-bg:     var(--action-hover);                   /* #EFF3F8 */
  --scl--cms-pages-mediaPage-table-row-selected-bg:  var(--action-hover);

  /* Grid */
  --scl--cms-pages-mediaPage-grid-gap:               18px;
}

/* ========================================
   PAGE ROOT
   ======================================== */

.scl--cms-pages-mediaPage {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 1920px;
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  padding: 10px 130px 40px 130px;
}

/* ========================================
   HEADER
   ======================================== */

.scl--cms-pages-mediaPage-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-right: 10px;
}

.scl--cms-pages-mediaPage-headerContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.scl--cms-pages-mediaPage-title {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-style: normal;
  font-weight: 600;
  font-size: var(--font-size-36, 36px);
  line-height: var(--line-height-40, 40px);
  color: var(--scl--cms-pages-mediaPage-title-color);
  margin: 0;
}

.scl--cms-pages-mediaPage-description {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-style: normal;
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-16, 16px);
  line-height: var(--line-height-22, 22px);
  letter-spacing: -0.01em;
  color: var(--scl--cms-pages-mediaPage-desc-color);
  margin: 0;
}

.scl--cms-pages-mediaPage-uploadeBtn {
  margin-top: 30px;
}

/* ========================================
   UPLOAD BUTTON
   ======================================== */

.scl--cms-pages-mediaPage-uploadBtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  gap: 6px;
  width: 91px;
  height: 30px;
  background: var(--scl--cms-pages-mediaPage-upload-bg);
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-12, 12px);
  line-height: var(--line-height-18, 18px);
  color: var(--scl--cms-pages-mediaPage-upload-color);
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.scl--cms-pages-mediaPage-uploadBtn:hover  { opacity: 0.88; }
.scl--cms-pages-mediaPage-uploadBtn:active { opacity: 0.75; }

.scl--cms-pages-mediaPage-uploadeBtn .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon {
  padding-right: 6px;
  border-right: 1px solid #F1F3F733 !important;
}

/* ========================================
   TOOLBAR
   ======================================== */

.scl--cms-pages-mediaPage-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-right: 10px;
}

.scl--cms-pages-mediaPage-filters {
  display: flex;
  align-items: center;
  gap: 15px;
}

.scl--cms-pages-mediaPage-filters-mediaType,
.scl-cms-pages-mediaPage-filters-status,
.scl--cms-pages-mediaPage-search {
  padding-bottom: 0 !important;
}

.scl--cms-pages-mediaPage-filters .scl--cms-components-selectField-container {
  padding-bottom: 0;
}

.scl--cms-pages-mediaPage-filters .scl--cms-components-selectField-assistive {
  display: none;
}

.scl--cms-pages-mediaPage-filters-mediaType {
  position: relative;
  display: flex;
  align-items: center;
  width: 125px;
}

.scl-cms-pages-mediaPage-filters-status {
  position: relative;
  display: flex;
  align-items: center;
  width: 135px;
}

/* ========================================
   SEARCH FIELD
   ======================================== */

.scl--cms-pages-mediaPage-search {
  position: relative;
  display: flex;
  align-items: center;
  width: 279px;
}

/* ========================================
   MEDIA GRID (grid view)
   ======================================== */

.scl--cms-pages-mediaPage-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--scl--cms-pages-mediaPage-grid-gap);
  align-items: start;
  padding-right: 10px;
}

.scl--cms-pages-mediaPage-cardWrapper {
  position: relative;
  flex-shrink: 0;
}

.scl--cms-pages-mediaPage-videoOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 3;
}

/* ========================================
   TABLE VIEW (list view)
   ======================================== */

.scl--cms-pages-mediaPage-tableWrapper {
  width: 100%;
  margin-bottom: 36px;
}

/* Checkbox column */
.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row .scl--components-table-dynamicTable-select-column,
.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-header-row .scl--components-table-dynamicTable-select-column {
  padding: 0;
}

.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-select-cell-content {
  padding: 0;
}

/* Row states */
.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row.selected {
  background: var(--scl--cms-pages-mediaPage-table-row-selected-bg) !important;
}

.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row:hover {
  background: var(--scl--cms-pages-mediaPage-table-row-hover-bg) !important;
}

.scl--cms-pages-mediaPage-tableWrapper .scl--components-pagination-container {
  margin-top: 10px;
}

/* ── File name cell ── */

.scl--cms-pages-mediaPage-fileNameCell {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.scl--cms-pages-mediaPage-thumbnail {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.scl--cms-pages-mediaPage-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.scl--cms-pages-mediaPage-fileName {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-size: var(--font-size-14, 14px);
  line-height: var(--line-height-20, 20px);
  color: var(--typography-text-body-primary, #323539);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ========================================
   ACTION BUTTONS (table row)
   — plain <button> elements, matching inbox style
   ======================================== */

.scl--cms-pages-mediaPage-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* shared base for all three action buttons */
.scl--cms-pages-mediaPage-eyeBtn,
.scl--cms-pages-mediaPage-editBtn,
.scl--cms-pages-mediaPage-deleteBtn {
  width: 19px;
  height: 19px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
  flex-shrink: 0;
}

/* ── View (eye) ── */
.scl--cms-pages-mediaPage-eyeBtn svg path,
.scl--cms-pages-mediaPage-eyeBtn svg circle {
  stroke: rgba(138, 139, 143, 1);
}

.scl--cms-pages-mediaPage-eyeBtn:hover {
  background: rgba(156, 156, 156, 0.24);
}

.scl--cms-pages-mediaPage-eyeBtn:hover svg path,
.scl--cms-pages-mediaPage-eyeBtn:hover svg circle {
  stroke: #323539;
}

/* ── Edit (pencil) ── */
.scl--cms-pages-mediaPage-editBtn svg path,
.scl--cms-pages-mediaPage-editBtn svg circle {
  stroke: rgba(138, 139, 143, 1);
}

.scl--cms-pages-mediaPage-editBtn:hover {
  background: rgba(156, 156, 156, 0.24);
}

.scl--cms-pages-mediaPage-editBtn:hover svg path,
.scl--cms-pages-mediaPage-editBtn:hover svg circle {
  stroke: #323539;
}

/* ── Delete (trash) ── */
.scl--cms-pages-mediaPage-deleteBtn svg path {
  stroke: rgba(254, 86, 107, 1);
}

.scl--cms-pages-mediaPage-deleteBtn:hover {
  background: rgba(255, 236, 239, 1);
}

/* ── Divider between edit and delete ── */
.scl--cms-pages-mediaPage-actionDivider {
  padding: 0;
  margin: 0;
  color: rgba(138, 139, 143, 0.2);
  font-size: 12px;
  user-select: none;
}

/* ========================================
   EMPTY STATE
   ======================================== */

.scl--cms-pages-mediaPage-emptyWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 20px;
}

.scl--components-confirmation-state {
  border-radius: 50%;
  width: 46px;
  height: 46px;
}

.scl--cms-pages-mediaPage-sentinel {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--cms-pages-mediaPage-loadingMore {
  font-size: 14px;
  color: var(--color-text-secondary, #888);
}
.scl--cms-pages-mediaPage-noMore{
  display: flex;
  justify-content: center;
}
.scl-components-button-RoundSqureButton-danger{
  background: #FE566B !important;
}
.scl-components-button-RoundSqureButton-danger:hover{
  background: #FF2D46 !important;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/media/media-card-page/css/mediaPage.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;6CAE6C;;AAE7C;EACE,oCAAoC;EACpC,sFAAsF,IAAI,YAAY;EACtG,wFAAwF,EAAE,YAAY;EACtG,uEAAuE,mBAAmB,YAAY;EACtG,uEAAuE,mBAAmB,YAAY;EACtG,wFAAwF,EAAE,YAAY;;EAEtG,kBAAkB;EAClB,iFAAiF,UAAU,YAAY;EACvG,2EAA2E,eAAe,YAAY;EACtG,2EAA2E;;EAE3E,kBAAkB;EAClB,sEAAsE,oBAAoB,YAAY;EACtG,6EAA6E,aAAa,YAAY;;EAEtG,UAAU;EACV,sEAAsE,oBAAoB,YAAY;EACtG,sEAAsE;;EAEtE,SAAS;EACT,uDAAuD;AACzD;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,0DAA0D;EAC1D,8BAA8B;AAChC;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;EACxC,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;EACxC,uBAAuB;EACvB,iDAAiD;EACjD,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;EACxC,mDAAmD;EACnD,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,6CAA6C,aAAa,EAAE;AAC5D,6CAA6C,aAAa,EAAE;;AAE5D;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,4EAA4E;AAC9E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0DAA0D;EAC1D,oCAAoC;EACpC,wCAAwC;EACxC,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;6CAG6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,6CAA6C;AAC7C;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,0CAA0C;AAC1C;EACE,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC","sourcesContent":["/* MediaPage.css */\n\n/* ========================================\n   LOCAL TOKENS — mapped to global :root\n   ======================================== */\n\n:root {\n  /* Typography — mapped from global */\n  --scl--cms-pages-mediaPage-title-color:            var(--typography-text-body-primary);   /* #323539 */\n  --scl--cms-pages-mediaPage-desc-color:             var(--typography-text-body-secondary); /* #8A8B8F */\n  --scl--cms-pages-mediaPage-filter-color:           var(--input-defualt);                  /* #8A8B8F */\n  --scl--cms-pages-mediaPage-filter-border:          var(--input-defualt);                  /* #8A8B8F */\n  --scl--cms-pages-mediaPage-search-icon-color:      var(--typography-text-body-secondary); /* #8A8B8F */\n\n  /* Upload button */\n  --scl--cms-pages-mediaPage-upload-bg:              var(--secondarycolors-blue400);         /* #4E9FFF */\n  --scl--cms-pages-mediaPage-upload-color:           var(--neutralcolors-100);              /* #FFFFFF */\n  --scl--cms-pages-mediaPage-upload-divider:         rgba(241, 243, 247, 0.2);\n\n  /* Dropdown menu */\n  --scl--cms-pages-mediaPage-menu-item-hover:        var(--action-hover);                   /* #EFF3F8 */\n  --scl--cms-pages-mediaPage-menu-item-active-color: var(--primarypalette-blue);            /* #2388FF */\n\n  /* Table */\n  --scl--cms-pages-mediaPage-table-row-hover-bg:     var(--action-hover);                   /* #EFF3F8 */\n  --scl--cms-pages-mediaPage-table-row-selected-bg:  var(--action-hover);\n\n  /* Grid */\n  --scl--cms-pages-mediaPage-grid-gap:               18px;\n}\n\n/* ========================================\n   PAGE ROOT\n   ======================================== */\n\n.scl--cms-pages-mediaPage {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-width: 1920px;\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  padding: 10px 130px 40px 130px;\n}\n\n/* ========================================\n   HEADER\n   ======================================== */\n\n.scl--cms-pages-mediaPage-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding-right: 10px;\n}\n\n.scl--cms-pages-mediaPage-headerContent {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.scl--cms-pages-mediaPage-title {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--font-size-36, 36px);\n  line-height: var(--line-height-40, 40px);\n  color: var(--scl--cms-pages-mediaPage-title-color);\n  margin: 0;\n}\n\n.scl--cms-pages-mediaPage-description {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-style: normal;\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-16, 16px);\n  line-height: var(--line-height-22, 22px);\n  letter-spacing: -0.01em;\n  color: var(--scl--cms-pages-mediaPage-desc-color);\n  margin: 0;\n}\n\n.scl--cms-pages-mediaPage-uploadeBtn {\n  margin-top: 30px;\n}\n\n/* ========================================\n   UPLOAD BUTTON\n   ======================================== */\n\n.scl--cms-pages-mediaPage-uploadBtn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px;\n  gap: 6px;\n  width: 91px;\n  height: 30px;\n  background: var(--scl--cms-pages-mediaPage-upload-bg);\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-12, 12px);\n  line-height: var(--line-height-18, 18px);\n  color: var(--scl--cms-pages-mediaPage-upload-color);\n  transition: opacity 0.2s ease;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-mediaPage-uploadBtn:hover  { opacity: 0.88; }\n.scl--cms-pages-mediaPage-uploadBtn:active { opacity: 0.75; }\n\n.scl--cms-pages-mediaPage-uploadeBtn .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon {\n  padding-right: 6px;\n  border-right: 1px solid #F1F3F733 !important;\n}\n\n/* ========================================\n   TOOLBAR\n   ======================================== */\n\n.scl--cms-pages-mediaPage-toolbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-right: 10px;\n}\n\n.scl--cms-pages-mediaPage-filters {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.scl--cms-pages-mediaPage-filters-mediaType,\n.scl-cms-pages-mediaPage-filters-status,\n.scl--cms-pages-mediaPage-search {\n  padding-bottom: 0 !important;\n}\n\n.scl--cms-pages-mediaPage-filters .scl--cms-components-selectField-container {\n  padding-bottom: 0;\n}\n\n.scl--cms-pages-mediaPage-filters .scl--cms-components-selectField-assistive {\n  display: none;\n}\n\n.scl--cms-pages-mediaPage-filters-mediaType {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 125px;\n}\n\n.scl-cms-pages-mediaPage-filters-status {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 135px;\n}\n\n/* ========================================\n   SEARCH FIELD\n   ======================================== */\n\n.scl--cms-pages-mediaPage-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 279px;\n}\n\n/* ========================================\n   MEDIA GRID (grid view)\n   ======================================== */\n\n.scl--cms-pages-mediaPage-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--scl--cms-pages-mediaPage-grid-gap);\n  align-items: start;\n  padding-right: 10px;\n}\n\n.scl--cms-pages-mediaPage-cardWrapper {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-mediaPage-videoOverlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 3;\n}\n\n/* ========================================\n   TABLE VIEW (list view)\n   ======================================== */\n\n.scl--cms-pages-mediaPage-tableWrapper {\n  width: 100%;\n  margin-bottom: 36px;\n}\n\n/* Checkbox column */\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row .scl--components-table-dynamicTable-select-column,\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-header-row .scl--components-table-dynamicTable-select-column {\n  padding: 0;\n}\n\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-select-cell-content {\n  padding: 0;\n}\n\n/* Row states */\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row.selected {\n  background: var(--scl--cms-pages-mediaPage-table-row-selected-bg) !important;\n}\n\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-table-dynamicTable-row:hover {\n  background: var(--scl--cms-pages-mediaPage-table-row-hover-bg) !important;\n}\n\n.scl--cms-pages-mediaPage-tableWrapper .scl--components-pagination-container {\n  margin-top: 10px;\n}\n\n/* ── File name cell ── */\n\n.scl--cms-pages-mediaPage-fileNameCell {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.scl--cms-pages-mediaPage-thumbnail {\n  width: 36px;\n  height: 36px;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-mediaPage-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.scl--cms-pages-mediaPage-fileName {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-size: var(--font-size-14, 14px);\n  line-height: var(--line-height-20, 20px);\n  color: var(--typography-text-body-primary, #323539);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ========================================\n   ACTION BUTTONS (table row)\n   — plain <button> elements, matching inbox style\n   ======================================== */\n\n.scl--cms-pages-mediaPage-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n/* shared base for all three action buttons */\n.scl--cms-pages-mediaPage-eyeBtn,\n.scl--cms-pages-mediaPage-editBtn,\n.scl--cms-pages-mediaPage-deleteBtn {\n  width: 19px;\n  height: 19px;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.3s;\n  flex-shrink: 0;\n}\n\n/* ── View (eye) ── */\n.scl--cms-pages-mediaPage-eyeBtn svg path,\n.scl--cms-pages-mediaPage-eyeBtn svg circle {\n  stroke: rgba(138, 139, 143, 1);\n}\n\n.scl--cms-pages-mediaPage-eyeBtn:hover {\n  background: rgba(156, 156, 156, 0.24);\n}\n\n.scl--cms-pages-mediaPage-eyeBtn:hover svg path,\n.scl--cms-pages-mediaPage-eyeBtn:hover svg circle {\n  stroke: #323539;\n}\n\n/* ── Edit (pencil) ── */\n.scl--cms-pages-mediaPage-editBtn svg path,\n.scl--cms-pages-mediaPage-editBtn svg circle {\n  stroke: rgba(138, 139, 143, 1);\n}\n\n.scl--cms-pages-mediaPage-editBtn:hover {\n  background: rgba(156, 156, 156, 0.24);\n}\n\n.scl--cms-pages-mediaPage-editBtn:hover svg path,\n.scl--cms-pages-mediaPage-editBtn:hover svg circle {\n  stroke: #323539;\n}\n\n/* ── Delete (trash) ── */\n.scl--cms-pages-mediaPage-deleteBtn svg path {\n  stroke: rgba(254, 86, 107, 1);\n}\n\n.scl--cms-pages-mediaPage-deleteBtn:hover {\n  background: rgba(255, 236, 239, 1);\n}\n\n/* ── Divider between edit and delete ── */\n.scl--cms-pages-mediaPage-actionDivider {\n  padding: 0;\n  margin: 0;\n  color: rgba(138, 139, 143, 0.2);\n  font-size: 12px;\n  user-select: none;\n}\n\n/* ========================================\n   EMPTY STATE\n   ======================================== */\n\n.scl--cms-pages-mediaPage-emptyWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 80px 20px;\n}\n\n.scl--components-confirmation-state {\n  border-radius: 50%;\n  width: 46px;\n  height: 46px;\n}\n\n.scl--cms-pages-mediaPage-sentinel {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--cms-pages-mediaPage-loadingMore {\n  font-size: 14px;\n  color: var(--color-text-secondary, #888);\n}\n.scl--cms-pages-mediaPage-noMore{\n  display: flex;\n  justify-content: center;\n}\n.scl-components-button-RoundSqureButton-danger{\n  background: #FE566B !important;\n}\n.scl-components-button-RoundSqureButton-danger:hover{\n  background: #FF2D46 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
